import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Layout, Button, Breadcrumb, Row, Col, Menu } from "antd";

import isAuthenticated from "../../utils/isAuthenticated";
import { logout } from "../../reducers/user/actions";
import {
  getRoleReadPermission,
  getSiteReadPermission,
  getUserReadPermission,
  getConsentReadPermission,
  getGeneralSettingsReadPermission,
  getTranslationPermission,
  getCustomFormsReadPermission,
  getThemePermission,
  getReadEtmfDocument,
  getCreateEtmfDocument,
  getReadRedcapApiConfigPermission,
  getReadDFDiscoverApiConfigPermission,
  getUserIsSuperUser,
  getUpdateRandomizationsConfigs,
  getEmailTemplateReadPermission,
  getSpecimenSampleReadPermission,
} from "../../reducers/user/selectors";

import classes from "./AdminSettings.css";
import { withNamespaces } from "react-i18next";

const routes = require("../../routes.json");

const { Content } = Layout;

class AdminSettings extends React.Component {
  render() {
    const {
      siteReadPermission,
      roleReadPermission,
      userReadPermission,
      consentReadPermission,
      generalSettingsReadPermission,
      customFormsReadPermission,
      translationPermission,
      themePermission,
    } = this.props;

    return (
      <div>
        <Helmet>
          <title>
            {this.props.i18n.t("Trial Management Portal")}:{" "}
            {this.props.i18n.t("Settings")}
          </title>
        </Helmet>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Admin Settings")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item>
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
            </Breadcrumb>

            <br />

            <Row gutter={[12, 12]} style={{ maxWidth: "1280px" }}>
              {(generalSettingsReadPermission ||
                siteReadPermission ||
                consentReadPermission) && (
                <Col lg={6}>
                  <h5 className="headline-default">
                    {this.props.i18n.t("General Settings")}
                  </h5>
                  {generalSettingsReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsGeneral}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:General Settings"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                  {siteReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsSites}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Site management"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                  {consentReadPermission && (
                    <p>
                      <Link to={routes.admin.consentEditor}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Consent management"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  <p>
                    <Link to={routes.admin.wizardConfig}>
                      <Button type="primary">
                        {this.props.i18n.t(
                          "NamespaceAdminSettings:Wizard Config"
                        )}
                      </Button>
                    </Link>
                  </p>

                  {(this.props.readEtmfDocument ||
                    this.props.createEtmfDocument) && (
                    <p>
                      <Link to={routes.admin.documentsEtmfSchema}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Document eTMF Schema"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {themePermission && (
                    <p>
                      <Link to={routes.admin.themeSettings}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Theme Settings"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {(this.props.getReadRedcapApiConfigPermission || this.props.getReadDFDiscoverApiConfigPermission) && (
                    <p>
                      <Link to={routes.admin.apiConfiguration}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:API Configuration"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {this.props.getUpdateRandomizationsConfigs && (
                    <p>
                      <Link to={routes.admin.permutedBlocks}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Permuted blocks generator"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {this.props.getSpecimenSampleReadPermission && (
                    <p>
                      <Link to={routes.admin.specimenSampleEditor}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Specimen Samples"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {this.props.getSpecimenSampleReadPermission && (
                    <p>
                      <Link to={routes.admin.specimenSampleSettings}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Specimen Sample Settings"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {this.props.getEmailTemplateReadPermission && (
                    <p>
                      <Link to={routes.admin.emailTemplates}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Email templates"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                </Col>
              )}

              {(userReadPermission ||
                roleReadPermission ||
                userReadPermission) && (
                <Col lg={6}>
                  <h5 className="headline-default">
                    {this.props.i18n.t("User Settings")}
                  </h5>

                  {userReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsUsers}>
                        <Button type="primary">
                          {this.props.i18n.t("User management")}
                        </Button>
                      </Link>
                    </p>
                  )}
                  {roleReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsRoles}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Role management"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                  {userReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsUsersBulk}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Bulk User management"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {userReadPermission && (
                    <p>
                      <Link to={routes.admin.settingsUsersPatientPortal}>
                        <Button type="primary">
                          {this.props.i18n.t("Patient Portal User Management")}
                        </Button>
                      </Link>
                    </p>
                  )}

                  {this.props.getUserIsSuperUser && (
                    <p>
                      <Link to={routes.admin.settingsRolesSuperAdmin}>
                        <Button type="primary">
                          {this.props.i18n.t("Active permissions")}
                        </Button>
                      </Link>
                    </p>
                  )}
                </Col>
              )}

              {customFormsReadPermission && (
                <Col lg={6}>
                  <h5 className="headline-default">
                    {this.props.i18n.t("Patient Events Settings")}
                  </h5>
                  <p>
                    <Link to={routes.admin.patientEvents}>
                      <Button type="primary">
                        {this.props.i18n.t(
                          "NamespaceAdminSettings:Patient Events Settings"
                        )}
                      </Button>
                    </Link>
                  </p>
                  <p>
                    <Link to={routes.admin.customFormsList}>
                      <Button type="primary">
                        {this.props.i18n.t(
                          "NamespaceAdminSettings:Custom Forms"
                        )}
                      </Button>
                    </Link>
                  </p>
                </Col>
              )}

              {(translationPermission || translationPermission) && (
                <Col lg={6}>
                  <h5 className="headline-default">
                    {this.props.i18n.t("Localization Settings")}
                  </h5>

                  {translationPermission && (
                    <p>
                      <Link to={routes.admin.languages}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Languages"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                  {translationPermission && (
                    <p>
                      <Link to={routes.admin.translations}>
                        <Button type="primary">
                          {this.props.i18n.t(
                            "NamespaceAdminSettings:Localization"
                          )}
                        </Button>
                      </Link>
                    </p>
                  )}
                </Col>
              )}
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  siteReadPermission: getSiteReadPermission(state),
  roleReadPermission: getRoleReadPermission(state),
  userReadPermission: getUserReadPermission(state),
  consentReadPermission: getConsentReadPermission(state),
  customFormsReadPermission: getCustomFormsReadPermission(state),
  generalSettingsReadPermission: getGeneralSettingsReadPermission(state),
  translationPermission: getTranslationPermission(state),
  themePermission: getThemePermission(state),
  readEtmfDocument: getReadEtmfDocument(state),
  createEtmfDocument: getCreateEtmfDocument(state),
  getReadRedcapApiConfigPermission: getReadRedcapApiConfigPermission(state),
  getReadDFDiscoverApiConfigPermission: getReadDFDiscoverApiConfigPermission(state),
  getUserIsSuperUser: getUserIsSuperUser(state),
  getUpdateRandomizationsConfigs: getUpdateRandomizationsConfigs(state),
  getSpecimenSampleReadPermission: getSpecimenSampleReadPermission(state),
  getEmailTemplateReadPermission: getEmailTemplateReadPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(AdminSettings))
);



// WEBPACK FOOTER //
// ./src/containers/AdminSettings/AdminSettings.js